export class VerifyWorkerId {
  static readonly type = '[Username API] Verify Worker ID';
  constructor(public workerId: string, public recaptchaV2Token: string, public recaptchaV3Token: string) {}
}

export class VerifySupplierId {
  static readonly type = '[Username API] Verify Supplier ID';
  constructor(public supplierId: string, public recaptchaV2Token: string, public recaptchaV3Token: string) {}
}
